import React, {Component} from "react";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';
import validator from "validator";
import UserHeader from "./UserHeader";
import Xhr from "../../helpers/Xhr";
import Loading from "../../components/Loading";

class UserPassword extends Component {
	state = {
		form     : {
			csrf             : '',
			password         : null,
			password_confirm : null,
			password_current : null,
		},
		messages : '',
		fetching : false,
		status   : '',
	};

	componentWillMount() {
		Xhr.changePassword().then((resp) => this.setState({form : {...resp.data.form}}));
	}

	errorBox(message) {
		return <div className="error">{message}</div>
	}

	required(value) {
		if ( value === null || validator.isEmpty(value) ) {
			return this.errorBox('Поле обязательно для заполнения!');
		}
	};

	passEquals(value) {
		if ( value.toString().trim() !== this.state.form.password.toString().trim() ) {
			return this.errorBox('Пароли не совпадают!');
		}
	}

	minLength(value) {
		if ( value.toString().trim().length < 6 ) {
			return this.errorBox('Минимум 6 букв и/или цифр!')
		}
	}

	inputChange(e) {
		const stateChange = {
			[e.target.name] : e.target.value
		};

		this.setState({form : {...this.state.form, ...stateChange}});
	}

	onSubmit(e) {
		e.preventDefault();
		this.setState({fetching : true});
		Xhr.changePasswordPost(this.state.form).then((resp) => this.setState({
			messages : resp.data.messages || '',
			status   : resp.status,
			fetching : false
		}))
	}

	render() {
		return (
			<Form ref={c => { this.form = c }} onSubmit={this.onSubmit.bind(this)}>
				<UserHeader text={'Смена пароля'}/>
				<div className="change-password">
					<div>Текущий пароль</div>
					<Input type="password"
					       name="password_current"
					       validations={[this.required.bind(this), this.minLength.bind(this)]}
					       onChange={this.inputChange.bind(this)}
					       value={this.state.form.password_current}/>

					<div>Новый пароль</div>
					<Input type="password"
					       name="password"
					       validations={[this.required.bind(this), this.minLength.bind(this)]}
					       onChange={this.inputChange.bind(this)}
					       value={this.state.form.password}/>

					<div>Повторите пароль</div>
					<Input type="password"
					       name="password_confirm"
					       validations={[this.required.bind(this), this.minLength.bind(this),
					                     this.passEquals.bind(this)]}
					       onChange={this.inputChange.bind(this)}
					       value={this.state.form.password_confirm}/>
				</div>
				<div className="buttons">
					<Button className="buttons__show">Изменить пароль</Button>
				</div>
				<div className={`change-password__messages ${this.state.status === 'error' && 'error'}`}>
					{this.state.fetching ? <Loading/> : this.state.messages}
				</div>
			</Form>
		);
	}
}

export default UserPassword;


// WEBPACK FOOTER //
// ./src/app/pages/User/UserPassword.js